import React from "react";
import { useCampaign } from "../../context/CampaignContext";
import "./Regulation.css";

export function Regulation() {
  const { campaign } = useCampaign();

  return (
    <section className="regulation" id="regulamento">
      <div className="container regulation__content" data-reveal>
        <p className="regulation__text">
          Para ler todas as regras nos mínimos detalhes, clique no botão abaixo
          e baixe o regulamento completo da promoção.
        </p>

        <a
          className="btn btn--yellow"
          href={campaign.regulationUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Ler regulamento completo (PDF)
        </a>

        <p className="regulation__certificate">{campaign.certificateNumber}</p>
      </div>
    </section>
  );
}
